import "./App.css";
import Tables from "./components/Tables";

function App() {
  return (
    <div className="App">
      <Tables />
    </div>
  );
}

export default App;
